<template>
  <div class="left-nav-inner">

    <a-menu :openKeys="openKeys ? openKeys : []" mode="inline"
      @openChange="onOpenChange" :selectedKeys="[$route.path]" :inlineCollapsed="this.collapsed" :style="{width: this.collapsed ? '70px' : ''}">

      <!-- 菜单 -->
      <template v-for="item in RouterList">
          <!-- 二级菜单 -->
          <template v-if="item.children && item.children.length">
            <a-sub-menu :key="item.key" :index="item.key"> 
              <template #title> <a-icon :type="item.icon"/><span>{{ item.title }}</span></template>
              <a-menu-item v-for="subItem in item.children" :key="subItem.mlink" :index="subItem.mlink" :id="subItem.mlink"
                @click="goPage(subItem)" style="padding-left: 40px;">
                <a-icon :type="subItem.icon" />
                <span>{{ subItem.title }}</span>
              </a-menu-item>
            </a-sub-menu>
          </template>
          <!-- 一级菜单 -->
          <template v-else>
            <a-menu-item :key="item.mlink" @click="goPage(item)">
              <a-icon v-if="item.icon" :type="item.icon" />
              <span>{{ item.title }}</span>
            </a-menu-item>
          </template>
        </template>
    </a-menu>
    
  </div>
</template>

<script>
import { NavMockService } from '@common/services/nav.service'
import { UserStatusService } from '@common/services/user-status.service';
export default {
  name: 'NavMenu',
  props: {
    collapsed: {
      type: Boolean,
      default: () => false,
    },//收起
  },
  data() {
    return {
      activeNav: '',
      rootSubmenuKeys: ['/management', '/contract', '/script', '/evaluation', '/home', '/template', '/user', '/attestation'],
      // 展开的父菜单项
      openKeys: [],
      // 选中的子菜单项
      RouterList: [],
    }
  },
  mounted() {
    this.RouterList = JSON.parse(sessionStorage.getItem('menuData'))
    if (!JSON.parse(sessionStorage.getItem('openKeys'))) {
      this.openKeys = []
    } else {
      if (this.collapsed) {
        this.openKeys = [];
      } else {
        this.openKeys.splice(0)
        this.openKeys = JSON.parse(sessionStorage.getItem('openKeys')); 
      }
    }
  },
  methods: {
    onOpenChange(openKeys) {
      this.openKeys = openKeys;
      if (!this.collapsed) {
        sessionStorage.setItem('openKeys', JSON.stringify(this.openKeys)); 
      }
    },
    // 跳转某一页
    goPage(item) {
      if (item.mlink && item.mlink != this.$route.path) {
        this.$router.push({ path: item.mlink })
        this.$emit('tabsInfo', item)
      }
    },
  },
}
</script>

<style scoped="scoped" lang="less">
.ant-menu {
  //ackground-color: #15194d;
  color: #ECEFF5;
  background: transparent;
}

/deep/ .ant-menu-submenu>.ant-menu {
  //background-color: #001529;
  color: #ECEFF5;
  background: transparent;
}

/deep/ .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  //background-color: #1890ff;
  background-color: rgba( 255, 255, 255, .21);
  color: #fff;
}

/deep/ .ant-menu-submenu-selected {
  color: #fff;
}

/deep/ .ant-menu-vertical .ant-menu-item::after, .ant-menu-vertical-left .ant-menu-item::after, .ant-menu-vertical-right .ant-menu-item::after, .ant-menu-inline .ant-menu-item::after {
    border-right: 4px solid #00FFD3;
}

/deep/ .ant-menu {
  // 菜单高度
  .ant-menu-item, .ant-menu-submenu > .ant-menu-submenu-title,.ant-menu-sub.ant-menu-inline > .ant-menu-item, .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    height: 45px;
    line-height: 45px;
    margin: 0 0 1px 0;
  }
  .ant-menu-item:hover, .ant-menu-item-active, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open, .ant-menu-submenu-active, .ant-menu-submenu-title:hover {
    color: #fff;
  }
  // 小三角颜色
  .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before, .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after, .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after, .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after, .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
    background-image: linear-gradient(to right, rgba(236, 239, 245), rgba(236, 239, 245));
  }
  .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after, .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after, .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after, .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after, .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before, .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before {
    background-image: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1));
  }

  // 划过菜单时浅背景色
  .ant-menu-item-active {
    background-color: rgba(255, 255, 255, .1);
  }
  .ant-menu-item:active, .ant-menu-submenu-title:active {
    background-color: rgba(255, 255, 255, .1);
  }



}

</style>